import { render, staticRenderFns } from "./ListModelosProjetos.vue?vue&type=template&id=35db2f86&"
import script from "./ListModelosProjetos.vue?vue&type=script&lang=js&"
export * from "./ListModelosProjetos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports